import { Autocomplete, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, IconButton, InputAdornment, InputLabel, Menu, MenuItem, Select, TextField, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { CommonGridToolBarWithExtraFilter, CommonPatientDetails } from '../../Components/Common Components/CommonComponents'
import { DataGrid } from "@mui/x-data-grid";
import { Colors } from '../../Styles/Colors';
import { ImagePaths } from '../../Utility/ImagePaths';
import SearchIcon from '@mui/icons-material/Search';
import { useHistory } from 'react-router-dom'
import { clearCachevalue, localGetItem, setCachevalue } from '../../Utility/Services/CacheProviderService';
import RestAPIService from '../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../Utility/API/Serviceurls';
import ToastMsg from '../../Components/ToastMsg/ToastMsg';
import Loader from '../../Components/Loader';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTime } from "luxon";
import PaymentsIcon from '@mui/icons-material/Payments';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ReportIcon from '@mui/icons-material/Report';
import { AmountFormat, ContentInTooltip } from '../../Components/CommonFunctions/CommonFunctions';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CreditTypeChangePop from '../FrontOffice/BillingTransaction/CreditTypeChangePop';

const RtWalkIn = (props) => {
    const history = useHistory();
    const loggedInUserInfo = JSON.parse(localGetItem('loggedInUserInfo'))
    const showPaymentStatusColumn = loggedInUserInfo?.permission_access?.common?.restrict_payment_status !== true
    const [page, setpage] = useState(0);
    const [pageSize, setpageSize] = useState(10);
    const [WalkInList, setWalkInList] = useState([]);
    const [isloader, setisloader] = useState(false);
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    const [selectedRegion, setselectedRegion] = useState(null);
    const [selectedTherapy, setselectedTherapy] = useState(null);
    const [selectedStatus, setselectedStatus] = useState("Pending");
    const [FilterDate, setFilterDate] = useState(null);
    const [SearchKey, setSearchKey] = useState("");
    const [anchorEl, setanchorEl] = useState(null);
    const [TherapyRegions, setTherapyRegions] = useState([]);
    const [TherapyMaster, setTherapyMaster] = useState([]);
    const [cancelSession, setCancelSession] = useState(null);
    const [selectedRow, setselectedRow] = useState(null);
    const [selectedCreditType, setSelectedCreditType] = useState(null);

    
    const errorMessage = (msg) => {
        seterrorMsgText(msg)
        seterrorMsg(true)
        setisloader(false)
    }

    const successMessage = (msg) => {
        setsuccessMsgText(msg)
        setsuccessMsg(true)
    }

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
        setsuccessMsg(false);
        setsuccessMsgText('');
    }

    useEffect(() => {
        GetTherapyRegions();
        GetTherapyMasters();
    }, [])

    useEffect(() => {
        GetStimulatorList()
    }, [selectedRegion, selectedTherapy, selectedStatus, FilterDate])

    const GetTherapyRegions = () => {
        RestAPIService.getAll(Serviceurls.TREATMENT_REGION_GET)
            .then((response) => {
                if (response.data.status === 'success') {
                    setTherapyRegions(response.data.data || []);
                }
            }).catch((error) => errorMessage(error?.response?.data?.message || error.message));
    };

    const GetTherapyMasters = () => {
        RestAPIService.getAll(Serviceurls.RADIO_THERAPY_GET)
            .then((response) => {
                if (response.data.status === 'success') {
                    setTherapyMaster(response.data.data || []);
                }
            }).catch((error) => errorMessage(error?.response?.data?.message || error.message));
    };

    const GetStimulatorList = () => {
        setisloader(true)
        let DateFilterKey = FilterDate ? DateTime.fromJSDate(new Date(FilterDate)).toFormat('yyyy-MM-dd') : ""
        RestAPIService.getAll(Serviceurls.RT_WALKIN_APPOINTMENTS + `?status=${selectedStatus}&region_id=${selectedRegion?.id || ""}&therapy_id=${selectedTherapy?.id || ""}&date=${DateFilterKey}`)
            .then((response) => {
                if (response.data.status === 'success') {
                    let List = response.data.data?.map((list) => ({
                        ...list,
                        temp_start_date: list?.start_date ? new Date(list?.start_date) : null
                    }))

                    setWalkInList(List || []);
                    setisloader(false)
                }
            }).catch((error) => errorMessage(error?.response?.data?.message || error.message));
    };

    const GetDetailedPrint = (Datas) => {
        try {
            RestAPIService.getAllPrint(Serviceurls.RT_DETAILED_PRINT + `?invoice_id=${Datas?.bill_id || ""}&walk_in_id=${Datas?.id || ""}`)
                .then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                }).catch((error) => {
                    errorMessage(error?.response?.data?.message || error?.message)
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }
    const GetApproximatedPrint = (Datas) => {
        try {
            RestAPIService.getAllPrint(Serviceurls.RT_APROXIMATE_DETAILED_PRINT + `?invoice_id=${Datas?.bill_id || ""}&walk_in_id=${Datas?.id || ""}`)
                .then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                }).catch((error) => {
                    errorMessage(error?.response?.data?.message || error?.message)
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const GetTreatmentPrint = (Datas) => {
        try {
            let ExtraParams = props?.isFromDoctor ? `&clinic_id=${localGetItem('SelectedDoctorClinicId')}` : ""
            RestAPIService.getAllPrint(Serviceurls.RT_TREATMENT_PRINT + `?therapy_id=${Datas?.patient_therapy_id || ""}${ExtraParams}`)
                .then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                }).catch((error) => {
                    errorMessage(error?.response?.data?.message || error?.message)
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }


    const postSimulation = (Data, Status) => {
        try {
            let StartDate = Data?.temp_start_date ? DateTime.fromJSDate(new Date(Data?.temp_start_date)).toFormat('yyyy-MM-dd') : null
            let data = {
                'start_date': StartDate,
                'status': Status,
                "patient_radiotherapy_id": Data?.id
            }
            setisloader(true)
            RestAPIService.updateWithOutId(data, Serviceurls.RT_STIMULATOR_LIST)
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        setisloader(false)
                        setCancelSession(null)
                        GetStimulatorList()
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
            // }
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const posrCrditTypeChage = (Action) => {
        try {
            let data = {
                'action': Action,
                'patient_id': selectedRow?.patient_id || null,
                'walk_in_id': selectedRow?.id || null,
            }
            if (Action === "change_credit_type") {
                data["credit_type"] = selectedCreditType
            }
            setisloader(true)
            RestAPIService.updateWithOutId(data, Serviceurls.RT_WALKIN_UPDATE)
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        setisloader(false)
                        setselectedRow(null)
                        setSelectedCreditType('')
                        GetStimulatorList()
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
            // }
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const tableView = () => {
        try {
            const gridToolBar = () => {
                return (
                    <Box>
                        <CommonGridToolBarWithExtraFilter />
                    </Box>
                )
            }
            WalkInList?.forEach((element, index) => element.sno = index + 1)
            const columns = [
                {
                    field: 'patient_names', headerName: 'Patient Details', flex: 0.15,
                    renderCell: (params) => (<Box component={'div'}>{<CommonPatientDetails data={params?.row} />}</Box>
                    ), valueGetter: (params) => {
                        const name = params.row?.patient_names || "";
                        const mobile = params.row?.mobile_number || "";
                        const UHID = params.row?.patient_uhid || "";
                        return `${name} ${mobile} ${UHID}`;
                    }
                },
                {
                    field: 'walk_in_number', headerName: 'WalkIn Number', flex: 0.10,
                    renderCell: (params) => (params?.row?.walk_in_number ? params?.row?.walk_in_number : "-")
                },
                {
                    field: 'doctor_name', headerName: 'Doctor Details', flex: 0.1,
                    renderCell: (params) => (params.row.doctor_name ? ContentInTooltip(params.row.doctor_name, 20) : '-')
                },
                {
                    field: 'therapy_name', headerName: 'Therapy Details', flex: 0.10,
                    renderCell: (params) => (<Box>
                        {params.row.therapy_name ? ContentInTooltip(params.row.therapy_name, 20) : '-'}
                        {params.row.region_name ? ContentInTooltip(params.row.region_name, 20) : '-'}
                    </Box>)
                },
                {
                    field: 'stimulator_name', headerName: 'Simulation Type', flex: 0.10,
                    renderCell: (params) => (params.row.stimulator_name ? ContentInTooltip(params.row.stimulator_name, 20) : '-')
                },
                {
                    field: 'credit_type', headerName: 'Credit Type', flex: 0.10,
                    renderCell: (params) => (
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', }}>
                            <Typography textTransform={'capitalize'} component={'div'} fontSize={"0.9vw"}>{params?.row?.credit_type ? params?.row?.credit_type : "-"}</Typography>
                            <Typography textTransform={'capitalize'} component={'div'} fontSize={"0.8vw"} >{params?.row?.credit_type === "Corporate credit" ? ContentInTooltip(params?.row?.company_name, 15) : params?.row?.credit_type === "Insurance credit" ? ContentInTooltip(params?.row?.insurance_company_name, 15) : ""}</Typography>
                        </Box>)
                },
                ...(showPaymentStatusColumn ? [{
                    field: 'current_8location', headerName: 'Payment Status', flex: 0.10,
                    renderCell: (params) => (
                        <Box>
                            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                <PaymentsIcon sx={{ fontSize: "0.9vw", marginRight: '0.4vw', color: '#616161' }} />
                                <Typography fontSize={"0.8vw"}>{`Bill : ${AmountFormat(params?.row?.bill_amount || 0)} `}</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                <CheckCircleIcon sx={{ fontSize: "0.9vw", marginRight: '0.4vw', color: 'green' }} />
                                <Typography color={"green"} fontSize={"0.8vw"}>{`Paid : ${AmountFormat(params?.row?.paid_amount || 0)} `}</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                <ReportIcon sx={{ fontSize: "0.9vw", marginRight: '0.4vw', color: "#B8170D" }} />
                                <Typography color={"#B8170D"} fontSize={"0.8vw"}>{`Balance : ${AmountFormat(params?.row?.balance_amount || 0)} `}</Typography>
                            </Box>
                        </Box>
                    )
                }] : []),
                {
                    field: 'action', headerName: 'Action', headerAlign: "center", flex: 0.05, align: "center",
                    renderCell: (params) => (<Box component={'div'} sx={{}}>
                        {
                            props?.isFromDoctor ?
                                <>
                                    <Tooltip title={"Treatment Print"} placement="top" arrow>
                                        <Button
                                            disabled={params?.row?.rt_bill_type !== "Billed"}
                                            onClick={() => { GetTreatmentPrint(params?.row) }}
                                            className='eMed_usrconf_btn' emed_tid='PO_requestList_print'>
                                            <img src={(params?.row?.rt_bill_type !== "Billed") ? ImagePaths.LabPrintIconOff.default : ImagePaths.PrintIcons.default} alt="print" style={{ width: '1.5vw', height: '1.5vw' }} />
                                        </Button>
                                    </Tooltip>
                                </> :
                                <>
                                    <Tooltip title={"Receive Payment"} placement="top" arrow>
                                        <Button
                                            disabled={params?.row?.appointment_status === "Cancelled"}
                                            onClick={() => {
                                                history?.push({ pathname: "/HospitalBilling/CashCounter", states: { FromRT: true, RtWalkInDetails: params?.row, return_path: "/RadiotherapyWalkIn", back_button_lable: "Back to RT WalkIn", } })
                                            }}
                                            className='eMed_usrconf_btn' emed_tid='PO_requestList_print'>
                                            <img src={(params?.row?.appointment_status !== "Cancelled") ? ImagePaths.CreateBill.default : ImagePaths.DisabledCreateBill.default} alt="Approval" style={{ width: '1.5vw', height: '1.5vw' }} />
                                        </Button>
                                    </Tooltip>
                                    <Tooltip title={"More"} placement='top' arrow>
                                        <IconButton
                                            emed_tid="drg_more_icon"
                                            disabled={(params?.row?.session_status === "Cancelled" || params?.row?.session_status === "Re-Scheduled")}
                                            onClick={(e) => {
                                                setanchorEl(e.currentTarget)
                                                setselectedRow(params.row)
                                            }}
                                        >
                                            <MoreVertIcon />
                                        </IconButton>
                                    </Tooltip>
                                    {(selectedRow?.sno == params?.row?.sno && anchorEl) ?
                                        <Menu
                                            anchorEl={anchorEl}
                                            open={Boolean(anchorEl)}
                                            onClose={() => {
                                                setanchorEl(null)
                                                setselectedRow(null)

                                            }}>
                                            <MenuItem className="eMed_drugMenu"
                                                disabled={params?.row?.appointment_status === "Cancelled"}
                                                onClick={() => {
                                                    setanchorEl(null)
                                                    setSelectedCreditType(params?.row?.credit_type)
                                                }}
                                            >{"Change Credit Type"}</MenuItem>
                                            <MenuItem disabled={params?.row?.rt_bill_type === "Billed" || params?.row?.appointment_status === "Cancelled"} className="eMed_drugMenu"
                                                onClick={() => {
                                                    setanchorEl(null)
                                                    posrCrditTypeChage("generate_bill")
                                                }}
                                            >{"Generate Bill"}</MenuItem>
                                            <MenuItem disabled={params?.row?.rt_bill_type !== "Billed"} className="eMed_drugMenu"
                                                onClick={() => {
                                                    setanchorEl(null)
                                                    setselectedRow(null)
                                                    GetDetailedPrint(params?.row)
                                                }}
                                            >{"Detailed Print"}</MenuItem>
                                            <MenuItem className="eMed_drugMenu"
                                                disabled={params?.row?.rt_bill_type !== "Billed"}
                                                onClick={() => {
                                                    setanchorEl(null)
                                                    setselectedRow(null)
                                                    GetTreatmentPrint(params?.row)
                                                }}
                                            >{"Treatment Print"}</MenuItem>
                                             <MenuItem disabled={params?.row?.rt_bill_type === "Billed"} className="eMed_drugMenu"
                                                onClick={() => {
                                                    setanchorEl(null)
                                                    setselectedRow(null)
                                                    GetApproximatedPrint(params?.row)
                                                }}
                                            >{"Approximate Detailed Bill"}</MenuItem>
                                        </Menu> : null}
                                </>
                        }

                    </Box>)
                },
            ];
            return (
                <Box sx={{ height: '72vh', marginTop: '.5vw', backgroundColor: 'white' }}>
                    <DataGrid
                        rows={WalkInList || []}
                        columns={columns}
                        getRowId={(row) => row['sno']}
                        page={page}
                        pageSize={pageSize}
                        localeText={{
                            toolbarColumns: "",
                            toolbarDensity: "",
                            toolbarExport: "",
                            toolbarFilters: "",
                            toolbarExportPrint: ""
                        }}
                        components={{
                            Toolbar: gridToolBar,
                            NoRowsOverlay: () => (
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                    {'No Records To Be Shown'}
                                </Box>
                            )
                        }}
                        onPageChange={(newPage) => { setpage(newPage) }}
                        onPageSizeChange={(newPageSize) => { setpageSize(newPageSize) }}
                        rowsPerPageOptions={[10, 20, 30]}
                        pagination
                        headerHeight={40}
                        density='comfortable'
                        disableSelectionOnClick
                        loading={isloader}
                        getRowClassName={(params) => {
                            if (params.row.appointment_status === "Cancelled") {
                                return 'eMed_OP_CancelPatient'
                            } else {
                                return null
                            }
                        }}
                    />
                </Box>
            )
        } catch (e) {

        }
    }

    const ClosePopUp = () => {
        setselectedRow(null)
    }
    const CrebillTypeChaged = () => {
        setselectedRow(null)
    }

    return (
        <Box sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
            <Box display={'flex'} justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
                <Box display={'flex'} justifyContent={'flex-start'} flexDirection={'row'} alignItems={'center'}>
                    <Autocomplete
                        size='small'
                        options={TherapyRegions}
                        sx={{ width: '20vw' }}
                        getOptionLabel={(option) => typeof (option) === 'string' ? option : option.treatment_region_name}
                        value={selectedRegion}
                        onChange={(e, value) => {
                            setselectedRegion(value)
                        }}
                        renderInput={(params) => <TextField autoComplete='off' {...params} label={"Select Region"} />}
                    />
                    <Autocomplete
                        size='small'
                        sx={{ width: '20vw', marginLeft: '1vw' }}
                        options={TherapyMaster}
                        getOptionLabel={(option) => typeof (option) === 'string' ? option : option.therapy_name}
                        value={selectedTherapy}
                        onChange={(e, value) => {
                            setselectedTherapy(value)
                        }}
                        renderInput={(params) => <TextField autoComplete='off' {...params} label={"Select Therapy"} />}
                    />
                    <FormControl size='small' sx={{ width: "20vw", marginLeft: '1vw' }}>
                        <InputLabel id="Dis_lay_Diet">{'Status'}</InputLabel>
                        <Select
                            value={selectedStatus}
                            label={'Status'}
                            onChange={(event) => {
                                setselectedStatus(event.target.value)
                                if (event.target.value === "Pending") {
                                    setFilterDate(null)
                                } else if (FilterDate === null) {
                                    setFilterDate(new Date())
                                }
                            }}
                        >
                            <MenuItem value={"Pending"}>{"Pending"}</MenuItem>
                            <MenuItem value={"Completed"}>{"Completed"}</MenuItem>
                            <MenuItem value={"Cancelled"}>{"Cancelled"}</MenuItem>
                        </Select>
                    </FormControl>
                    {selectedStatus !== "Pending" ? <Box>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                value={FilterDate ? FilterDate : null}
                                name={"datePicker"}
                                inputFormat='DD-MM-YYYY'
                                views={["year", "month", "day"]}
                                onChange={(newDate) => {
                                    setFilterDate(newDate);
                                }}
                                renderInput={(params) => <TextField
                                    {...params}
                                    label={"Date"}
                                    variant="outlined"
                                    onKeyDown={(e) => e.preventDefault()}
                                    sx={{ width: '15dvw', marginLeft: '1vw' }}
                                    size='small'
                                />}
                            />
                        </LocalizationProvider>
                    </Box> : null}
                </Box>
            </Box>
            <Box>
                {tableView()}
            </Box>
            {errorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={errorMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
            {successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={successMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
            <Dialog open={cancelSession !== null} >
                {/* <DialogTitle id="eMed_MaxDialog_Title">{"Alert !"}</DialogTitle> */}
                <DialogContent sx={{ padding: "1dvw", width: '25dvw', display: 'flex', alignItems: 'center', justifyContent: "center" }}>
                    <Typography >{`Are You Sure ? Do you want to cancel this therapy?`}</Typography>
                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' color="error" size='small' className='eMed_Filter_Btns' onClick={() => { setCancelSession(null) }}>{"Close"}</Button>
                    <Button variant='contained' color="error" size='small' className='eMed_Filter_Btns' onClick={() => {

                        postSimulation(cancelSession, "Cancelled")
                    }}>{"Confirm"}</Button>
                </DialogActions>
            </Dialog>
            <Dialog open={(selectedRow !== null && selectedCreditType)} onClose={() => {
                setselectedRow(null)
                setSelectedCreditType('')
            }}>
                <DialogTitle id="eMed_MaxDialog_Title">{"Change Credit Type"}</DialogTitle>
                <DialogContent sx={{ padding: "1dvw", width: '25dvw', display: 'flex', alignItems: 'center', justifyContent: "center", flexDirection: 'column' }}>
                    <CommonPatientDetails data={selectedRow} />
                    <Box>
                        <FormControl sx={{ width: "20vw", marginTop: '1vw' }} size="small">
                            <InputLabel>{"Select Credit Type"}</InputLabel>
                            <Select
                                value={selectedCreditType}
                                label={"Select Credit Type"}
                                onChange={(event) => {
                                    setSelectedCreditType(event.target.value)
                                }}
                            >
                                <MenuItem value={"Patient credit"} >{"Patient Credit"}</MenuItem>
                                <MenuItem value={"Corporate credit"} >{"Corporate Credit"}</MenuItem>
                                <MenuItem value={"Insurance credit"} >{"Insurance Credit"}</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' color="primary" size='small' className='eMed_Filter_Btns' onClick={() => {
                        setselectedRow(null)
                        setSelectedCreditType('')
                    }}>{"Close"}</Button>
                    <Button variant='contained' color="primary" size='small' className='eMed_Filter_Btns' onClick={() => {
                        posrCrditTypeChage("change_credit_type")
                    }}>{"Change Type"}</Button>
                </DialogActions>
            </Dialog>
            {console.log(WalkInList)}
        </Box>
    )
}

export default RtWalkIn
